import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";

export const Emotional = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} aria-labelledby="emotional-heading" className="relative bg-navy px-5 py-24 sm:px-8 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div className="relative">
            <div className="absolute -left-4 -top-4 h-full w-full rounded-[2.5rem] border-2 border-gold/60" aria-hidden="true" />
            <div className="relative overflow-hidden rounded-[2.5rem] rounded-tr-[9rem]">
              <motion.img
                style={{ y, scale: 1.18 }}
                src="/images/parent.webp"
                alt="A mother and her young child laughing together on the sofa while looking at a saved drawing on a phone"
                loading="lazy"
                width="1400"
                height="939"
                className="aspect-[4/3.4] w-full object-cover"
              />
            </div>
          </div>
        </Reveal>
        <div>
          <Reveal><p className="eyebrow text-gold">What matters most</p></Reveal>
          <Reveal delay={0.08}>
            <h2 id="emotional-heading" className="mt-5 font-heading text-3xl sm:text-4xl lg:text-[3.3rem] font-black leading-[1.12] tracking-tight text-cream">
              You don't have to keep every piece of paper to keep <span className="italic text-gold">what matters.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-7 max-w-lg text-base md:text-lg leading-relaxed text-cream/85">
              The proud grin. The story told at the kitchen table. The age they were when they first wrote their name. Those are the parts of childhood worth holding on to—and they fit beautifully in a photo and a few words.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <p className="mt-5 max-w-lg text-base md:text-lg leading-relaxed text-cream/85">
              Let the paper go, gently. Keep the memory.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <CtaButton testId="emotional-cta-button" source="emotional" variant="gold" className="mt-10" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
